import React from 'react';
import { Grid, Typography, Box, FormControlLabel, Checkbox, Paper } from '@mui/material';

const TestsSection = ({ formData, handleChange }) => {
  const tests = Object.keys(formData.pre_surgical_tests);

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 5: Pre-Surgical Tests Plan
      </Typography>
      
      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
        <Grid container spacing={1}>
          {tests.map((test) => (
            <Grid item xs={12} sm={4} key={test}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.pre_surgical_tests[test]}
                    onChange={handleChange}
                    name={`pre_surgical_tests.${test}`}
                    color="primary"
                  />
                }
                label={test.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase())}
              />
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Box>
  );
};

export default TestsSection;
